// 消息通知接口
import request from '@/utils/request'

// 分页查询当前用户消息记录
export const getUserMessageList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MESSAGE + '/api/sysMessage/pageUserMessage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询单条消息
export const getMessageDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MESSAGE + '/api/sysMessage/getMessage',
		method: 'get',
		headers: {
			isToken: true
		},
		params
	})
}

// 查询单条消息
export const getCountUserMessage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MESSAGE + '/api/sysMessage/countUserMessage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 标记消息为已读
export const handleSetRead = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MESSAGE + '/api/sysMessage/batchConsume',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 删除消息
export const handleDeleteMessages = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MESSAGE + '/api/sysMessage/batchDelete',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 删除消息
export const handleAllDelete = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MESSAGE + '/api/sysMessage/allDelete',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}
